import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { Button } from "antd";

const BackButton = () => {
  const history = useHistory();
  return (
    <div className="mb-3" style={{ position: "relative", zIndex: 1000 }}>
      <Button
        size="large"
        type="default"
        icon={<ArrowLeftOutlined />}
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          history.push("/home");
        }}
      >
        <span className="ml-2">Voltar</span>
      </Button>
    </div>
  );
};

export default BackButton;
